import OrderTypeIcon from '@ancon/wildcat-ui/web/orderweb/OrderTypeIcon'
import '@ancon/wildcat-ui/web/orderweb/OrderTypeIcon/OrderTypeIcon.css'

export default OrderTypeIcon
